import { Outlet } from 'react-router-dom';
import { useGetReportCurrentStep } from './hooks/useGetReportCurrentStep';
import { ReportFormProvider } from './hooks/useReportFormContext';
import { ReportStepper } from './components/organisms/report-stepper/ReportStepper';
export const NewReport = () => {
  const currentStep = useGetReportCurrentStep();

  return (
    <ReportFormProvider>
      <div>
        <p>New Reports</p>
        <ReportStepper currentStep={currentStep ?? 3} />
        <Outlet />
      </div>
    </ReportFormProvider>
  );
};
